<template>
  <el-dialog :title="$l('archives/audioPopOver/downlRec')+' - '+data.name" :visible.sync="data.visible" >

    <el-form>
        <el-row>
            <el-col :span="24" class="range-title">
                {{$l('archives/audioPopOver/range')}}
            </el-col>
            <el-col :span="2" class="range-value">
                0 s
            </el-col>
            <el-col :span="20">
                <el-slider v-model="data.selection" range show-stops v-bind:max="data.length"></el-slider>
            </el-col>
            <el-col :span="2" class="range-value">
                {{data.length}} s
            </el-col>
        </el-row>
    </el-form>
    <div class="foot">
        <el-button @click="downloadClicked" type="primary"> {{$l('archives/Download')}}  </el-button>
        <el-button @click="data.visible=false" class="close-button" type="danger"> {{$l('archives/Close')}}  </el-button>
    </div>
</el-dialog>

</template>

<style scoped>
    .range-title{
        font-size: 15px;
        font-weight: 600;
        text-align: center;
    }
    .range-value{
        font-weight: 600;
        font-size: 15px;
        text-align: center;
        margin-top: 8px;
    }
    .foot{
        margin-top: 30px;
        margin-bottom: -10px;
    }
    .close-button{
        float: right;
    }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as api from '@/api'


export default {
    props:['data'],
    methods: {
        ...mapActions([
            'setDownloading',
            'setDownloadingProgress'
        ]),
        downloadClicked: function(){
            var url = '/api/file-action&&action=download&type=audio&files='+this.data.name+'&start='+this.data.selection[0]+'&stop='+this.data.selection[1]+'&time='+Date.now();
            this.setDownloading({enabled: true, progress: 0})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        let percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
            //window.location.href = url;
            this.data.visible = false;
        }
    }
}
</script>





// WEBPACK FOOTER //
// AudioDownloadDialog.vue?a58ddd88